// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QuEc","footer":"styles_footer__FFyx2","passCodeTooltip":"styles_passCodeTooltip__cpihX"};